import { EventStatus, BetRadarSocketTypes } from "@nxplatform/platform-entities/sport/common-sport.entities";
var CasinoGamesView = /* @__PURE__ */ ((CasinoGamesView2) => {
  CasinoGamesView2[CasinoGamesView2["base"] = 0] = "base";
  CasinoGamesView2[CasinoGamesView2["slider"] = 1] = "slider";
  CasinoGamesView2[CasinoGamesView2["grid"] = 2] = "grid";
  return CasinoGamesView2;
})(CasinoGamesView || {});
const AvailablePlatformName = {
  platformBase: "1",
  bet20Win: "2",
  tonyNL: "3",
  tonyKE: "4",
  tonyEE: "5",
  tonyLV: "6",
  tonyNG: "7",
  tonyES: "8",
  tonyCA: "9",
  tonyPT: "10",
  tonyAU: "11",
  bet22: "12",
  bet22Senegal: "13",
  bet22Cameroon: "14",
  bet22Congo: "15",
  bet22Mozambique: "16",
  bet22Zambia: "17",
  bet22Burundi: "18",
  bet22Ghana: "19",
  ivibet: "20",
  nationalBase: "21",
  nationalBizzo: "22",
  hellspinBase: "23",
  sofobetBase: "24",
  vave: "25",
  tonywinae: "26",
  granawin: "27",
  eeivibet: "28",
  eehellspin: "29",
  eenational: "30",
  eebizzo: "31",
  dragonslots: "32",
  slotsgem: "33",
  none: ""
};
var CabinetRoutes = /* @__PURE__ */ ((CabinetRoutes2) => {
  CabinetRoutes2["deposit"] = "/deposit";
  CabinetRoutes2["details"] = "/personal-details";
  CabinetRoutes2["preferences"] = "/preferences";
  CabinetRoutes2["verification"] = "/verification";
  CabinetRoutes2["verificationInfo"] = "/verification/info";
  CabinetRoutes2["transaction"] = "/transaction-history";
  CabinetRoutes2["forecast"] = "/forecast-history";
  CabinetRoutes2["withdrawals"] = "/withdrawal";
  CabinetRoutes2["promotions"] = "/promotions";
  CabinetRoutes2["promotionsHistory"] = "/promotions-history";
  CabinetRoutes2["cabinetRewards"] = "/rewards";
  CabinetRoutes2["coins"] = "/coins";
  CabinetRoutes2["history"] = "/betting-history";
  CabinetRoutes2["casino"] = "/casino-history";
  CabinetRoutes2["casinoSession"] = "/casino-session-history";
  CabinetRoutes2["jackpot"] = "/jackpot-history";
  CabinetRoutes2["reports"] = "/reports";
  CabinetRoutes2["overview"] = "/overview";
  CabinetRoutes2["newLimits"] = "/my-limits";
  CabinetRoutes2["addLimit"] = "/my-limits/:type";
  CabinetRoutes2["editLimit"] = "/my-limits/:type/:id";
  CabinetRoutes2["paymentIQTestDeposit"] = "/deposit-payment";
  CabinetRoutes2["paymentIQTestWithdrawal"] = "/withdrawal-payment";
  CabinetRoutes2["security"] = "/security";
  CabinetRoutes2["referrals"] = "/referrals";
  CabinetRoutes2["statistics"] = "/statistics";
  CabinetRoutes2["responsibleGamblingLimits"] = "/limits";
  CabinetRoutes2["responsibleGamblingExclusion"] = "/limits/exclusion";
  CabinetRoutes2["responsibleGamblingDeactivation"] = "/limits/deactivation";
  CabinetRoutes2["responsibleGamblingCoolingOff"] = "/cooling-off";
  CabinetRoutes2["reportsAndMessages"] = "/reports-and-messages";
  return CabinetRoutes2;
})(CabinetRoutes || {});
var TogglerMarketsModifiers = /* @__PURE__ */ ((TogglerMarketsModifiers2) => {
  TogglerMarketsModifiers2["bgDarkGrey"] = "bg-dark-grey";
  return TogglerMarketsModifiers2;
})(TogglerMarketsModifiers || {});
var CustomerHaveEstoniaPersonalCode = /* @__PURE__ */ ((CustomerHaveEstoniaPersonalCode2) => {
  CustomerHaveEstoniaPersonalCode2[CustomerHaveEstoniaPersonalCode2["yes"] = 1] = "yes";
  CustomerHaveEstoniaPersonalCode2[CustomerHaveEstoniaPersonalCode2["no"] = 2] = "no";
  return CustomerHaveEstoniaPersonalCode2;
})(CustomerHaveEstoniaPersonalCode || {});
var LeaguePageSections = /* @__PURE__ */ ((LeaguePageSections2) => {
  LeaguePageSections2["league"] = "league";
  LeaguePageSections2["outrights"] = "outrights";
  return LeaguePageSections2;
})(LeaguePageSections || {});
var SearchTabs = /* @__PURE__ */ ((SearchTabs2) => {
  SearchTabs2["EVENTS"] = "events";
  SearchTabs2["LEAGUES"] = "leagues";
  SearchTabs2["SPORTS"] = "sports";
  return SearchTabs2;
})(SearchTabs || {});
var FeedVendorType = /* @__PURE__ */ ((FeedVendorType2) => {
  FeedVendorType2[FeedVendorType2["betRadar"] = 1] = "betRadar";
  FeedVendorType2[FeedVendorType2["S2G"] = 6] = "S2G";
  FeedVendorType2[FeedVendorType2["BetBy"] = 7] = "BetBy";
  return FeedVendorType2;
})(FeedVendorType || {});
var deviceChangeSocketTypes = /* @__PURE__ */ ((deviceChangeSocketTypes2) => {
  deviceChangeSocketTypes2["dispatchDeviceData"] = "dispatch-device-data";
  return deviceChangeSocketTypes2;
})(deviceChangeSocketTypes || {});
var BetSumSocketTypes = /* @__PURE__ */ ((BetSumSocketTypes2) => {
  BetSumSocketTypes2["sumUpdated"] = "sum-updated";
  return BetSumSocketTypes2;
})(BetSumSocketTypes || {});
var CurrencySocketTypes = /* @__PURE__ */ ((CurrencySocketTypes2) => {
  CurrencySocketTypes2["updateRates"] = "rates-updated";
  return CurrencySocketTypes2;
})(CurrencySocketTypes || {});
var OddsBoosterSocketTypes = /* @__PURE__ */ ((OddsBoosterSocketTypes2) => {
  OddsBoosterSocketTypes2["bannersUpdate"] = "boosted-odds-banner";
  OddsBoosterSocketTypes2["oddsUpdate"] = "boosted-odds";
  return OddsBoosterSocketTypes2;
})(OddsBoosterSocketTypes || {});
var SportTypes = /* @__PURE__ */ ((SportTypes2) => {
  SportTypes2["football"] = "football";
  SportTypes2["basketBall"] = "basketball";
  SportTypes2["tennis"] = "tennis";
  SportTypes2["volleybal"] = "volleybal";
  SportTypes2["snooker"] = "snooker";
  SportTypes2["tableTennis"] = "tabletennis";
  SportTypes2["badminton"] = "badminton";
  SportTypes2["baseball"] = "baseball";
  SportTypes2["americanFootbal"] = "americanfootbal";
  SportTypes2["darts"] = "darts";
  SportTypes2["esports"] = "esports";
  SportTypes2["F1"] = "f1";
  SportTypes2["cycling"] = "cycling";
  return SportTypes2;
})(SportTypes || {});
var AdditionalCoverageSource = /* @__PURE__ */ ((AdditionalCoverageSource2) => {
  AdditionalCoverageSource2["tv"] = "tv";
  AdditionalCoverageSource2["venue"] = "venue";
  return AdditionalCoverageSource2;
})(AdditionalCoverageSource || {});
var EventTeamsModifiers = /* @__PURE__ */ ((EventTeamsModifiers2) => {
  EventTeamsModifiers2["big"] = "big";
  EventTeamsModifiers2["comma"] = "comma";
  return EventTeamsModifiers2;
})(EventTeamsModifiers || {});
var ListOfSportsSvgModifiers = /* @__PURE__ */ ((ListOfSportsSvgModifiers2) => {
  ListOfSportsSvgModifiers2["default"] = "default";
  ListOfSportsSvgModifiers2["marginRight"] = "margin-right";
  ListOfSportsSvgModifiers2["filterGrey"] = "filter-grey";
  ListOfSportsSvgModifiers2["small"] = "small";
  ListOfSportsSvgModifiers2["middle"] = "middle";
  ListOfSportsSvgModifiers2["big"] = "big";
  return ListOfSportsSvgModifiers2;
})(ListOfSportsSvgModifiers || {});
var FullEventPageStubImgModifiers = /* @__PURE__ */ ((FullEventPageStubImgModifiers2) => {
  FullEventPageStubImgModifiers2["absolute"] = "absolute";
  FullEventPageStubImgModifiers2["marginLeft"] = "margin-left";
  FullEventPageStubImgModifiers2["hiddenOnTablet"] = "hidden-on-tablet";
  FullEventPageStubImgModifiers2["lightGradientBg"] = "light-gradient-bg";
  return FullEventPageStubImgModifiers2;
})(FullEventPageStubImgModifiers || {});
var UIModalPortalModifiers = /* @__PURE__ */ ((UIModalPortalModifiers2) => {
  UIModalPortalModifiers2["default"] = "ui-modal-portal";
  UIModalPortalModifiers2["beforeCreate"] = "ui-modal-portal--before-create";
  UIModalPortalModifiers2["useAnimation"] = "ui-modal-portal--with-animation";
  UIModalPortalModifiers2["sectionView"] = "ui-modal-portal--sectionView";
  UIModalPortalModifiers2["fullHeight"] = "ui-modal-portal--full-height";
  UIModalPortalModifiers2["offsetForTimeBlock"] = "ui-modal-portal--time-offset";
  UIModalPortalModifiers2["withShadow"] = "ui-modal-portal--with-shadow";
  UIModalPortalModifiers2["isModern"] = "ui-modal-portal--modern";
  UIModalPortalModifiers2["isBlurModal"] = "ui-modal-portal--blur";
  UIModalPortalModifiers2["bottomPosition"] = "ui-modal-portal--bottom";
  UIModalPortalModifiers2["scrollDisabled"] = "ui-modal-portal--scroll-disabled";
  UIModalPortalModifiers2["closeOnSwipe"] = "ui-modal-portal--close-on-swipe";
  return UIModalPortalModifiers2;
})(UIModalPortalModifiers || {});
var SportType = /* @__PURE__ */ ((SportType2) => {
  SportType2[SportType2["baseSport"] = 0] = "baseSport";
  SportType2[SportType2["races"] = 1] = "races";
  SportType2[SportType2["cyberSport"] = 2] = "cyberSport";
  return SportType2;
})(SportType || {});
var TeamNumber = /* @__PURE__ */ ((TeamNumber2) => {
  TeamNumber2[TeamNumber2["home"] = 1] = "home";
  TeamNumber2[TeamNumber2["away"] = 2] = "away";
  return TeamNumber2;
})(TeamNumber || {});
var DocumentStatus = /* @__PURE__ */ ((DocumentStatus2) => {
  DocumentStatus2[DocumentStatus2["PENDING"] = 0] = "PENDING";
  DocumentStatus2[DocumentStatus2["APPROVED"] = 1] = "APPROVED";
  DocumentStatus2[DocumentStatus2["CANCELED"] = 2] = "CANCELED";
  DocumentStatus2[DocumentStatus2["SEEN"] = 3] = "SEEN";
  return DocumentStatus2;
})(DocumentStatus || {});
var TopTabsMap = /* @__PURE__ */ ((TopTabsMap2) => {
  TopTabsMap2["events"] = "1";
  TopTabsMap2["leagues"] = "2";
  return TopTabsMap2;
})(TopTabsMap || {});
var FullEventHeaderModifier = /* @__PURE__ */ ((FullEventHeaderModifier2) => {
  FullEventHeaderModifier2["default"] = "default";
  FullEventHeaderModifier2["black"] = "black";
  return FullEventHeaderModifier2;
})(FullEventHeaderModifier || {});
var menuItemsTypes = /* @__PURE__ */ ((menuItemsTypes2) => {
  menuItemsTypes2[menuItemsTypes2["line"] = 0] = "line";
  menuItemsTypes2[menuItemsTypes2["live"] = 1] = "live";
  menuItemsTypes2[menuItemsTypes2["casino"] = 2] = "casino";
  return menuItemsTypes2;
})(menuItemsTypes || {});
var Sections = /* @__PURE__ */ ((Sections2) => {
  Sections2["all"] = "all";
  Sections2["live"] = "live";
  Sections2["line"] = "prematch";
  return Sections2;
})(Sections || {});
var EventSectionModifiers = /* @__PURE__ */ ((EventSectionModifiers2) => {
  EventSectionModifiers2["blue"] = "c_blue";
  EventSectionModifiers2["red"] = "c_red";
  EventSectionModifiers2["base"] = "";
  return EventSectionModifiers2;
})(EventSectionModifiers || {});
const EventStoppedStatus = [
  EventStatus.stopped,
  EventStatus.dead,
  EventStatus.ended,
  EventStatus.closed,
  EventStatus.cancelled
];
const EventClosedStatus = [
  EventStatus.ended,
  EventStatus.closed,
  EventStatus.dead
];
var SportGetParamsRelations = /* @__PURE__ */ ((SportGetParamsRelations2) => {
  SportGetParamsRelations2["league"] = "league";
  SportGetParamsRelations2["odds"] = "odds";
  SportGetParamsRelations2["result"] = "result";
  SportGetParamsRelations2["team"] = "competitors";
  SportGetParamsRelations2["players"] = "players";
  SportGetParamsRelations2["variants"] = "variants";
  SportGetParamsRelations2["sportCategories"] = "sportCategories";
  SportGetParamsRelations2["withMarketsCount"] = "withMarketsCount";
  SportGetParamsRelations2["broadcasts"] = "broadcasts";
  SportGetParamsRelations2["statistics"] = "statistics";
  SportGetParamsRelations2["additionalInfo"] = "additionalInfo";
  SportGetParamsRelations2["tips"] = "tips";
  SportGetParamsRelations2["sport"] = "sport";
  SportGetParamsRelations2["marketOrder"] = "marketOrder";
  SportGetParamsRelations2["competitors"] = "competitors";
  SportGetParamsRelations2["pinnedEvents"] = "pinnedEvents";
  SportGetParamsRelations2["events"] = "events";
  return SportGetParamsRelations2;
})(SportGetParamsRelations || {});
var TimeFormatOptions = /* @__PURE__ */ ((TimeFormatOptions2) => {
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_24"] = 1] = "TIME_FORMAT_24";
  TimeFormatOptions2[TimeFormatOptions2["TIME_FORMAT_12"] = 2] = "TIME_FORMAT_12";
  return TimeFormatOptions2;
})(TimeFormatOptions || {});
var ForecastTypes = /* @__PURE__ */ ((ForecastTypes2) => {
  ForecastTypes2[ForecastTypes2["pending"] = 3] = "pending";
  ForecastTypes2[ForecastTypes2["lost"] = 2] = "lost";
  ForecastTypes2[ForecastTypes2["won"] = 1] = "won";
  ForecastTypes2[ForecastTypes2["all"] = 0] = "all";
  return ForecastTypes2;
})(ForecastTypes || {});
const mappedBetRadarEvenTypes = {
  [BetRadarSocketTypes.close]: EventStatus.closed,
  [BetRadarSocketTypes.startLive]: EventStatus.online,
  [BetRadarSocketTypes.eventStopped]: EventStatus.stopped,
  [BetRadarSocketTypes.ended]: EventStatus.ended
};
var PathCompPointNames = /* @__PURE__ */ ((PathCompPointNames2) => {
  PathCompPointNames2["type"] = "type";
  return PathCompPointNames2;
})(PathCompPointNames || {});
var CompPointTypesNames = /* @__PURE__ */ ((CompPointTypesNames2) => {
  CompPointTypesNames2["sport"] = "sport";
  CompPointTypesNames2["casino"] = "casino";
  return CompPointTypesNames2;
})(CompPointTypesNames || {});
var WebViewPromotionTypes = /* @__PURE__ */ ((WebViewPromotionTypes2) => {
  WebViewPromotionTypes2["sport"] = "sport";
  WebViewPromotionTypes2["casino"] = "casino";
  WebViewPromotionTypes2["history"] = "history";
  return WebViewPromotionTypes2;
})(WebViewPromotionTypes || {});
var RegistrationProvidersList = /* @__PURE__ */ ((RegistrationProvidersList2) => {
  RegistrationProvidersList2[RegistrationProvidersList2["SMART_ID"] = 1] = "SMART_ID";
  RegistrationProvidersList2[RegistrationProvidersList2["MOBILE_ID"] = 2] = "MOBILE_ID";
  RegistrationProvidersList2[RegistrationProvidersList2["EPARAKSTS"] = 3] = "EPARAKSTS";
  return RegistrationProvidersList2;
})(RegistrationProvidersList || {});
var SectionTitleTypes = /* @__PURE__ */ ((SectionTitleTypes2) => {
  SectionTitleTypes2["main"] = "h1";
  SectionTitleTypes2["secondary"] = "h2";
  SectionTitleTypes2["default"] = "div";
  SectionTitleTypes2["third"] = "h3";
  return SectionTitleTypes2;
})(SectionTitleTypes || {});
var CustomerSessionParams = /* @__PURE__ */ ((CustomerSessionParams2) => {
  CustomerSessionParams2["deposit"] = "deposit";
  CustomerSessionParams2["withdrawal"] = "withdrawal";
  return CustomerSessionParams2;
})(CustomerSessionParams || {});
var LocationSmartSession = /* @__PURE__ */ ((LocationSmartSession2) => {
  LocationSmartSession2["LocationSmartHtml"] = "LOCATION-SMART-HTML-SESSION-ID";
  LocationSmartSession2["LocationSmartDevice"] = "LOCATION-SMART-DEVICE-SESSION-ID";
  return LocationSmartSession2;
})(LocationSmartSession || {});
const liveStatusTitle = "Live";
var MarketsListValue = /* @__PURE__ */ ((MarketsListValue2) => {
  MarketsListValue2["first"] = "1x2";
  MarketsListValue2["total"] = "Total";
  MarketsListValue2["handicap"] = "Handicap";
  MarketsListValue2["doubles"] = "Doubles";
  MarketsListValue2["setWinner"] = "SetWinner";
  MarketsListValue2["gameWinner"] = "GameWinner";
  return MarketsListValue2;
})(MarketsListValue || {});
var SentryEnvironments = /* @__PURE__ */ ((SentryEnvironments2) => {
  SentryEnvironments2["prod"] = "prod";
  SentryEnvironments2["staging"] = "staging";
  return SentryEnvironments2;
})(SentryEnvironments || {});
var ForecastRulesPlatform = /* @__PURE__ */ ((ForecastRulesPlatform2) => {
  ForecastRulesPlatform2["curacao"] = "curacao";
  ForecastRulesPlatform2["tonybet"] = "tonybet";
  return ForecastRulesPlatform2;
})(ForecastRulesPlatform || {});
var SportRoutes = /* @__PURE__ */ ((SportRoutes2) => {
  SportRoutes2["allSports"] = "allsports";
  SportRoutes2["leagues"] = "leagues";
  return SportRoutes2;
})(SportRoutes || {});
var DepositType = /* @__PURE__ */ ((DepositType2) => {
  DepositType2["basic"] = "basic";
  DepositType2["modal"] = "modal";
  return DepositType2;
})(DepositType || {});
var HomePageBannerLinkKey = /* @__PURE__ */ ((HomePageBannerLinkKey2) => {
  HomePageBannerLinkKey2["slider1"] = "slider1";
  HomePageBannerLinkKey2["slider2"] = "slider2";
  HomePageBannerLinkKey2["slider3"] = "slider3";
  HomePageBannerLinkKey2["slider4"] = "slider4";
  HomePageBannerLinkKey2["slider5"] = "slider5";
  HomePageBannerLinkKey2["slider6"] = "slider6";
  HomePageBannerLinkKey2["slider7"] = "slider7";
  HomePageBannerLinkKey2["slider8"] = "slider8";
  HomePageBannerLinkKey2["slider9"] = "slider9";
  HomePageBannerLinkKey2["slider10"] = "slider10";
  return HomePageBannerLinkKey2;
})(HomePageBannerLinkKey || {});
var NewMainPageComponents = /* @__PURE__ */ ((NewMainPageComponents2) => {
  NewMainPageComponents2["banner"] = "banner";
  NewMainPageComponents2["footer"] = "footer";
  NewMainPageComponents2["asideMenu"] = "asideMenu";
  NewMainPageComponents2["searchMenu"] = "searchMenu";
  NewMainPageComponents2["quickLinks"] = "quickLinks";
  NewMainPageComponents2["popularMenu"] = "popularMenu";
  NewMainPageComponents2["sportMenu"] = "sportMenu";
  NewMainPageComponents2["mobileFeaturesMenu"] = "mobileFeaturesMenu";
  NewMainPageComponents2["promotionsSections"] = "promotionsSections";
  NewMainPageComponents2["casinoGameSection"] = "casinoGameSection";
  NewMainPageComponents2["latestWinners"] = "latestWinners";
  NewMainPageComponents2["incomingBets"] = "incomingBets";
  NewMainPageComponents2["mobileBottomMenu"] = "mobileBottomMenu";
  NewMainPageComponents2["casinoGameProvidersFilter"] = "casinoGameProvidersFilter";
  NewMainPageComponents2["featuresToggle"] = "featuresToggle";
  NewMainPageComponents2["mobileMenuWithQuickLinks"] = "mobileMenuWithQuickLinks";
  NewMainPageComponents2["stories"] = "stories";
  return NewMainPageComponents2;
})(NewMainPageComponents || {});
var QuickLinks = /* @__PURE__ */ ((QuickLinks2) => {
  QuickLinks2["home"] = "home";
  QuickLinks2["favorites"] = "favorites";
  QuickLinks2["live"] = "live";
  QuickLinks2["sport"] = "sport";
  QuickLinks2["casino"] = "casino";
  QuickLinks2["liveCasino"] = "liveCasino";
  QuickLinks2["racing"] = "racing";
  QuickLinks2["promotions"] = "promotions";
  QuickLinks2["boostedOdds"] = "boostedOdds";
  QuickLinks2["forecasts"] = "forecasts";
  QuickLinks2["results"] = "results";
  QuickLinks2["crash"] = "crash";
  QuickLinks2["kennoLotto"] = "kennoLotto";
  QuickLinks2["incomingBets"] = "incomingBets";
  QuickLinks2["lootBoxes"] = "lootBoxes";
  QuickLinks2["jackpots"] = "jackpots";
  return QuickLinks2;
})(QuickLinks || {});
var MobileBottomMenuTitle = /* @__PURE__ */ ((MobileBottomMenuTitle2) => {
  MobileBottomMenuTitle2["home"] = "home";
  MobileBottomMenuTitle2["sports"] = "sports";
  MobileBottomMenuTitle2["live"] = "live";
  MobileBottomMenuTitle2["prematch"] = "prematch";
  MobileBottomMenuTitle2["betslip"] = "betslip";
  MobileBottomMenuTitle2["filter"] = "filter";
  MobileBottomMenuTitle2["casino"] = "casino";
  MobileBottomMenuTitle2["signup"] = "signup";
  MobileBottomMenuTitle2["profile"] = "profile";
  MobileBottomMenuTitle2["jackpots"] = "jackpots";
  MobileBottomMenuTitle2["liveCasino"] = "liveCasino";
  MobileBottomMenuTitle2["promotions"] = "promotions";
  return MobileBottomMenuTitle2;
})(MobileBottomMenuTitle || {});
var MobileFeaturesMenuNames = /* @__PURE__ */ ((MobileFeaturesMenuNames2) => {
  MobileFeaturesMenuNames2["search"] = "search";
  MobileFeaturesMenuNames2["live"] = "live";
  MobileFeaturesMenuNames2["boosts"] = "boosts";
  MobileFeaturesMenuNames2["incomingBets"] = "incomingBets";
  MobileFeaturesMenuNames2["favorites"] = "favorites";
  return MobileFeaturesMenuNames2;
})(MobileFeaturesMenuNames || {});
var StoriesItemFormat = /* @__PURE__ */ ((StoriesItemFormat2) => {
  StoriesItemFormat2["thin"] = "thin";
  StoriesItemFormat2["wide"] = "wide";
  return StoriesItemFormat2;
})(StoriesItemFormat || {});
var StoriesItemTypes = /* @__PURE__ */ ((StoriesItemTypes2) => {
  StoriesItemTypes2["casinoVipProgram"] = "casinoVipProgram";
  StoriesItemTypes2["sportVipProgram"] = "sportVipProgram";
  return StoriesItemTypes2;
})(StoriesItemTypes || {});
var SnackbarTypes = /* @__PURE__ */ ((SnackbarTypes2) => {
  SnackbarTypes2["danger"] = "danger";
  SnackbarTypes2["warning"] = "warning";
  SnackbarTypes2["success"] = "success";
  SnackbarTypes2["pending"] = "pending";
  return SnackbarTypes2;
})(SnackbarTypes || {});
var Directions = /* @__PURE__ */ ((Directions2) => {
  Directions2["ltr"] = "ltr";
  Directions2["rtl"] = "rtl";
  return Directions2;
})(Directions || {});
var CardHolder = /* @__PURE__ */ ((CardHolder2) => {
  CardHolder2["home"] = "home";
  CardHolder2["away"] = "away";
  return CardHolder2;
})(CardHolder || {});
var FavoriteType = /* @__PURE__ */ ((FavoriteType2) => {
  FavoriteType2["LEAGUE"] = "league";
  FavoriteType2["EVENT"] = "event";
  FavoriteType2["COMPETITOR"] = "competitor";
  FavoriteType2["MARKET"] = "market";
  return FavoriteType2;
})(FavoriteType || {});
var NoFavoritesType = /* @__PURE__ */ ((NoFavoritesType2) => {
  NoFavoritesType2["EVENTS"] = "events";
  NoFavoritesType2["LEAGUES"] = "leagues";
  NoFavoritesType2["COMPETITORS"] = "competitors";
  NoFavoritesType2["MARKETS"] = "markets";
  return NoFavoritesType2;
})(NoFavoritesType || {});
var RegistrationConfigTypes = /* @__PURE__ */ ((RegistrationConfigTypes2) => {
  RegistrationConfigTypes2["base"] = "base";
  RegistrationConfigTypes2["onestep"] = "one-step";
  return RegistrationConfigTypes2;
})(RegistrationConfigTypes || {});
var SectionTrackingNames = /* @__PURE__ */ ((SectionTrackingNames2) => {
  SectionTrackingNames2["live"] = "live";
  SectionTrackingNames2["allGames"] = "all-games";
  SectionTrackingNames2["liveAllGames"] = "live-all-games";
  SectionTrackingNames2["mainPageGames"] = "main-page-games";
  SectionTrackingNames2["mainPagePopularGames"] = "main-page-popular-games";
  SectionTrackingNames2["mainPageNewGames"] = "main-page-new-games";
  SectionTrackingNames2["mainPageAsideGames"] = "main-page-aside-games";
  SectionTrackingNames2["mainPageAsideLiveGames"] = "main-page-aside-live-games";
  SectionTrackingNames2["search"] = "search";
  SectionTrackingNames2["searchLive"] = "search-live";
  SectionTrackingNames2["searchModal"] = "search-modal";
  SectionTrackingNames2["producer"] = "producer";
  SectionTrackingNames2["liveProducer"] = "live-producer";
  SectionTrackingNames2["latestWinnersCasino"] = "latest-winners-casino";
  SectionTrackingNames2["latestWinnersHof"] = "latest-winners-hof";
  SectionTrackingNames2["hofTopWinners"] = "hof-top-winners";
  SectionTrackingNames2["freespinPopUp"] = "freespin-pop-up";
  SectionTrackingNames2["headerAviatorGame"] = "header-aviator-game";
  SectionTrackingNames2["headerCrashGame"] = "header-crash-game";
  return SectionTrackingNames2;
})(SectionTrackingNames || {});
var MobileBottomMenuView = /* @__PURE__ */ ((MobileBottomMenuView2) => {
  MobileBottomMenuView2["default"] = "default";
  MobileBottomMenuView2["frontSettings"] = "frontSettings";
  MobileBottomMenuView2["cms"] = "cms";
  return MobileBottomMenuView2;
})(MobileBottomMenuView || {});
var ViewAccountType = /* @__PURE__ */ ((ViewAccountType2) => {
  ViewAccountType2["fiat"] = "fiat";
  ViewAccountType2["crypto"] = "crypto";
  return ViewAccountType2;
})(ViewAccountType || {});
var EventSectionRenderType = /* @__PURE__ */ ((EventSectionRenderType2) => {
  EventSectionRenderType2["topLive"] = "top-live";
  EventSectionRenderType2["topLine"] = "top-line";
  EventSectionRenderType2["sportLive"] = "sport-live";
  EventSectionRenderType2["sportLine"] = "sport-line";
  return EventSectionRenderType2;
})(EventSectionRenderType || {});
var CashierPaymentMethodCategories = /* @__PURE__ */ ((CashierPaymentMethodCategories2) => {
  CashierPaymentMethodCategories2["recommended"] = "recommended";
  return CashierPaymentMethodCategories2;
})(CashierPaymentMethodCategories || {});
var GamePreloaderImagesSizes = /* @__PURE__ */ ((GamePreloaderImagesSizes2) => {
  GamePreloaderImagesSizes2["small"] = "190x190";
  GamePreloaderImagesSizes2["big"] = "380x380";
  GamePreloaderImagesSizes2["s6"] = "164x220";
  return GamePreloaderImagesSizes2;
})(GamePreloaderImagesSizes || {});
var ConfirmationPopupName = /* @__PURE__ */ ((ConfirmationPopupName2) => {
  ConfirmationPopupName2["coolingOff"] = "coolingOff";
  ConfirmationPopupName2["fixedSelfExclusion"] = "fixedSelfExclusion";
  ConfirmationPopupName2["selfExclusion"] = "selfExclusion";
  ConfirmationPopupName2["selfDelete"] = "selfDelete";
  return ConfirmationPopupName2;
})(ConfirmationPopupName || {});
var CashierTheme = /* @__PURE__ */ ((CashierTheme2) => {
  CashierTheme2["dark"] = "dark";
  CashierTheme2["light"] = "light";
  return CashierTheme2;
})(CashierTheme || {});
export {
  AdditionalCoverageSource,
  AvailablePlatformName,
  BetSumSocketTypes,
  CabinetRoutes,
  CardHolder,
  CashierPaymentMethodCategories,
  CashierTheme,
  CasinoGamesView,
  CompPointTypesNames,
  ConfirmationPopupName,
  CurrencySocketTypes,
  CustomerHaveEstoniaPersonalCode,
  CustomerSessionParams,
  DepositType,
  Directions,
  DocumentStatus,
  EventClosedStatus,
  EventSectionModifiers,
  EventSectionRenderType,
  EventStoppedStatus,
  EventTeamsModifiers,
  FavoriteType,
  FeedVendorType,
  ForecastRulesPlatform,
  ForecastTypes,
  FullEventHeaderModifier,
  FullEventPageStubImgModifiers,
  GamePreloaderImagesSizes,
  HomePageBannerLinkKey,
  LeaguePageSections,
  ListOfSportsSvgModifiers,
  LocationSmartSession,
  MarketsListValue,
  MobileBottomMenuTitle,
  MobileBottomMenuView,
  MobileFeaturesMenuNames,
  NewMainPageComponents,
  NoFavoritesType,
  OddsBoosterSocketTypes,
  PathCompPointNames,
  QuickLinks,
  RegistrationConfigTypes,
  RegistrationProvidersList,
  SearchTabs,
  SectionTitleTypes,
  SectionTrackingNames,
  Sections,
  SentryEnvironments,
  SnackbarTypes,
  SportGetParamsRelations,
  SportRoutes,
  SportType,
  SportTypes,
  StoriesItemFormat,
  StoriesItemTypes,
  TeamNumber,
  TimeFormatOptions,
  TogglerMarketsModifiers,
  TopTabsMap,
  UIModalPortalModifiers,
  ViewAccountType,
  WebViewPromotionTypes,
  deviceChangeSocketTypes,
  liveStatusTitle,
  mappedBetRadarEvenTypes,
  menuItemsTypes
};
